import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import contactImg from "../assets/img/contact-img.svg";

export const Contact = () => {
    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
    };

    const [formDetails, setFormDetails] = useState(formInitialDetails);
    const [buttonText, setButtonText] = useState('Send Message');
    const [status, setStatus] = useState({});

    const onFormUpdate = (category, value) => {
        setFormDetails({ ...formDetails, [category]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setButtonText('Sending...');
        let response = await fetch("https://localhost:5000/contact", {
            method: "POST",
            headers: { "Content-Type": "Application/json;charset=utf-8" },
            body: JSON.stringify(formDetails),
        });
        setButtonText("Send Message");
        let result = response.json();
        setFormDetails(formInitialDetails);
        if (result.code === 200) {
            setStatus({ success: true, message: "Message sent successfully!" });
        } else {
            setStatus({ success: false, message: "Something went wrong. Please try again." });
        }
    };

    const fadeUp = {
        hidden: { opacity: 0, y: 24 },
        visible: (i = 0) => ({
            opacity: 1, y: 0,
            transition: { duration: 0.6, delay: i * 0.1, ease: [0.4, 0, 0.2, 1] },
        }),
    };

    return (
        <section className="contact" id="connect">
            <Container>
                <Row className="align-items-center">
                    <Col md={6}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-80px" }}
                        >
                            <motion.div variants={fadeUp} custom={0}>
                                <img src={contactImg} alt="Contact illustration" />
                            </motion.div>
                        </motion.div>
                    </Col>

                    <Col md={6}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-80px" }}
                        >
                            <motion.h2 variants={fadeUp} custom={0}>Let's Build Together</motion.h2>
                            <motion.p className="contact-subtitle" variants={fadeUp} custom={1}>
                                Based in Nigeria — available to clients worldwide. Whether you
                                need a high-performance website, an SEO strategy, or a full
                                digital presence, I'd love to hear about your project.
                            </motion.p>

                            <motion.form onSubmit={handleSubmit} variants={fadeUp} custom={2}>
                                <Row>
                                    <Col sm={6} className="px-1">
                                        <input
                                            type="text"
                                            value={formDetails.firstName}
                                            placeholder="First Name"
                                            onChange={(e) => onFormUpdate('firstName', e.target.value)}
                                        />
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input
                                            type="text"
                                            value={formDetails.lastName}
                                            placeholder="Last Name"
                                            onChange={(e) => onFormUpdate('lastName', e.target.value)}
                                        />
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input
                                            type="email"
                                            value={formDetails.email}
                                            placeholder="Email Address"
                                            onChange={(e) => onFormUpdate('email', e.target.value)}
                                        />
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input
                                            type="tel"
                                            value={formDetails.phone}
                                            placeholder="Phone (optional)"
                                            onChange={(e) => onFormUpdate('phone', e.target.value)}
                                        />
                                    </Col>
                                    <Col className="px-1">
                                        <textarea
                                            rows="5"
                                            value={formDetails.message}
                                            placeholder="Tell me about your project..."
                                            onChange={(e) => onFormUpdate('message', e.target.value)}
                                        />
                                        <button type="submit">
                                            <span>{buttonText}</span>
                                        </button>
                                    </Col>
                                    {status.message && (
                                        <Col>
                                            <p className={status.success === false ? "danger" : "success"}>
                                                {status.message}
                                            </p>
                                        </Col>
                                    )}
                                </Row>
                            </motion.form>
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
